import React from "react";
import { useNavigate } from "react-router-dom";
import { skills } from "../data";
import styles from "../styles/pages/SkillPage.module.css";
import ProjectIntegration from "../components/ProjectIntegration";

const SkillPage = ({ skill }) => {
    const { languages, tools, api } = skills;
    const mergedSkills = languages.concat(tools, api);
    console.log(mergedSkills);

    const navigate = useNavigate();

    return (
        <div className={styles.skillPage}>
            <div className={styles.head}>
                <div className={styles.left}>
                    <h1 className={styles.skillName}>{skill.name}</h1>
                    <img
                        src={skill.icon}
                        alt={`${skill.name} icon`}
                        className={styles.skillIcon}
                    />
                </div>
                <div className={styles.right}>
                    <h3 className={styles.skillUsage}>
                        What is {skill.name} ?
                    </h3>
                    <p className={styles.skillDescription}>
                        {skill.description}
                    </p>
                    <h3 className={styles.skillUsage}>
                        How I used {skill.name}:
                    </h3>
                    <p className={styles.skillUsageDescription}>
                        {skill.usage}
                    </p>
                </div>
            </div>
            <h3 className={styles.relatedProjects}>
                I used {skill.name} in multiples projects including theses ones:
            </h3>
            <ul className={styles.projectList}>
                {skill.projects.map((project) => (
                    <li className={styles.projectItem}>
                        {<ProjectIntegration projectID={project} />}
                    </li>
                ))}
            </ul>
            <p className={styles.relatedProjectsParagraph}>
                feel free to explore thoses projects to get a better view on my
                capabilities in this domain.
            </p>
            <button
                onClick={() => navigate("/")}
                className={styles.backButton}
            >
                Back to Home
            </button>
        </div>
    );
};

export default SkillPage;
